module.exports = __webpack_public_path__ + "img/0.1a7a68b5.jpg";